import { Routes } from '@angular/router';
import { privatePagesGuard } from '@core/guards/auth/private-pages.guard';
import { desktopGuard, mobileGuard } from '@core/guards/device.guard';
import { metaReconnectGuard } from '@core/guards/sync/meta-reconnect.guard';
import { MainContentComponent } from '@core/layout/main-content/main-content.component';
import { ENVIRONMENTS } from '@environments/base-env';
import { AUTH_ROUTES } from '@features/auth/auth.routes';
import { PageNotFoundComponent } from '@features/page-not-found.component';
import { ModalMobileService } from '@mobile/services/modal-mobile.service';
import { APP_SLUGS } from '@routes/routes.types';
import { DEV_ROUTE } from 'src/dev/dev.routes';
import { environment } from 'src/environments/environment';
import { MAIN_ROUTES } from './main.routes';
import { MOBILE_ROUTES } from './mobile.routes';
import { aiAgentsResolver } from './resolvers/ai-agents.resolver';
import { departmentsResolver } from './resolvers/departments.resolver';
import { pipelineResolver } from './resolvers/pipelines.resolver';
import { usersResolver } from './resolvers/users.resolver';

const GLOBAL_RESOLVERS = {
    users: usersResolver,
    departments: departmentsResolver,
    aiAgents: aiAgentsResolver,
    pipeline: pipelineResolver,
};

export const APP_ROUTES: Routes = [
    {
        path: APP_SLUGS.AUTH,
        children: AUTH_ROUTES,
    },
    {
        path: APP_SLUGS.MAIN,
        canActivate: [privatePagesGuard, metaReconnectGuard, mobileGuard],
        resolve: GLOBAL_RESOLVERS,
        component: MainContentComponent,
        children: MAIN_ROUTES,
    },
    {
        path: APP_SLUGS.mobile,
        canActivate: [privatePagesGuard, desktopGuard],
        resolve: GLOBAL_RESOLVERS,
        providers: [ModalMobileService],
        loadComponent: () => import('../mobile/mobile.component').then(m => m.MobileComponent),
        children: MOBILE_ROUTES,
    },
    {
        // Push-notification click landing: resolves to the mobile or desktop route.
        path: APP_SLUGS.notify,
        loadComponent: () =>
            import('@core/push/push-landing.component').then(m => m.PushLandingComponent),
    },
    {
        path: APP_SLUGS.FROM_SHOPIFY,
        loadComponent: () =>
            import('../features/from-shopify.component').then(m => m.FromShopifyComponent),
    },
    {
        // Standalone embeddable chat widget — own auth, no app shell/guards.
        path: APP_SLUGS.widget,
        loadChildren: () =>
            import('@features/agent-chat/widget/widget.routes').then(m => m.WIDGET_ROUTE),
    },
];

if (environment.mode !== ENVIRONMENTS.prod) {
    APP_ROUTES.push(DEV_ROUTE);
}

/* "not found" routes must be last */
APP_ROUTES.push(
    { path: '', pathMatch: 'full', redirectTo: environment.front.home },
    { path: APP_SLUGS.NOT_FOUND, title: 'Page not found', component: PageNotFoundComponent },
    { path: '**', redirectTo: 'not-found' }
);
